// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useRole } from "../roleContext";

// export default function RequireRole({ allow = [], children }) {
//   const { loading, role } = useRole();

//   if (loading) return <div className="p-6 text-sm text-gray-500">Checking access…</div>;
//   if (!allow.includes(role)) return <Navigate to="/forbidden" replace />;
//   return children;
// }
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { resolveRole } from "../roles";

export default function RequireRole({ allow = [], children }) {
  const [ok, setOk] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) { setOk(false); return; }
      const r = await resolveRole();
      setOk(allow.includes(r));
    });
    return () => unsub();
  }, [allow]);

  if (ok === null) return <div className="p-6 text-sm text-gray-500">Checking access…</div>;
  if (!ok) return <Navigate to="/forbidden" replace />;
  return children;
}
